import { coreColorVars, coreFromSettings, deriveAllCssVars, themeDefaults } from './config';
// The setting that names the base. The rest are the palette's CSS variables.
const BASE_KEY = 'theme';
const isTheme = (value) => value === 'light' || value === 'dark' || value === 'custom';
// Null for a tour that has not chosen a theme, which shows in its community's colors.
export const tourThemeOf = (settings) => {
    var _a;
    const base = (_a = settings.find(setting => setting.key === BASE_KEY)) === null || _a === void 0 ? void 0 : _a.value;
    return isTheme(base) ? { base, custom: coreFromSettings(settings) } : null;
};
export const tourThemeSettings = (theme) => [
    { key: BASE_KEY, value: theme.base },
    ...Object.keys(coreColorVars).map(name => ({ key: coreColorVars[name], value: theme.custom[name] })),
];
export const colorsOf = (theme) => theme.base === 'custom' ? theme.custom : themeDefaults[theme.base];
// WCAG relative luminance and contrast ratio, for the Custom colors' legibility note.
const luminance = (hex) => {
    const h = hex.replace('#', '');
    const [r, g, b] = [0, 2, 4]
        .map(i => parseInt(h.slice(i, i + 2), 16) / 255)
        .map(c => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
export const contrast = (a, b) => {
    const [light, dark] = [luminance(a), luminance(b)].sort((x, y) => y - x);
    return (light + 0.05) / (dark + 0.05);
};
// Bootstrap's color mode follows the background, so inputs and cards read against it.
export const colorModeOf = (colors) => luminance(colors.Background) < 0.4 ? 'dark' : 'light';
// Moves each channel of a hex color the given share of the way toward white.
const lift = (hex, share) => '#' + [0, 2, 4]
    .map(i => parseInt(hex.replace('#', '').slice(i, i + 2), 16))
    .map(c => Math.round(c + (255 - c) * share).toString(16).padStart(2, '0'))
    .join('');
// Every variable a page reads, for a tour's colors. deriveAllCssVars takes the surface (panels, bands,
// and in dark mode the inputs) from the border, which only suits a light background; on a dark one
// that comes out pale, so there the surface is the background lifted a little instead.
export const tourCssVars = (colors) => {
    const vars = deriveAllCssVars(colors);
    return colorModeOf(colors) === 'dark' ? Object.assign(Object.assign({}, vars), { '--color-surface': lift(colors.Background, 0.08) }) : vars;
};
